<div class="p-1 verification-validation" [ngClass]="{ 'alert-danger': hasError }">
  <ng-content />
  <p class="form-text text-danger" *ngIf="errorMessage">
    <strong>{{ errorMessage }}</strong>
  </p>
</div>
